<template>
  <v-app>
    <v-navigation-drawer temporary touchless right
                         fixed enable-resize-watcher disable-route-watcher
                         v-model="navigation.drawer" app
                         v-if="isLandingPage() || isImpressum() || isPrivacy()">
      <v-list class="app-menu-wrapper">
        <p style="text-align: right; margin-right: 15px;">
          <a class="close-menu" @click.stop="navigation.drawer = !navigation.drawer">
            <v-icon large>{{icons.close}}</v-icon>
          </a>
        </p>
        <v-list-item v-if="!isLandingPage()">
          <v-list-item-content @click="goToLanding()">
            <v-list-item-title>
              {{ $t("menu.home") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isLandingPage()">
          <v-list-item-content @click.stop="closeMenu('#about')">
            <v-list-item-title>
              {{ $t("menu.about") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isLandingPage()">
          <v-list-item-content @click.stop="closeMenu('#events')">
            <v-list-item-title>
              {{ $t("menu.events") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isLandingPage()">
          <v-list-item-content @click.stop="closeMenu('#partner')">
            <v-list-item-title>
              {{ $t("menu.partner") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isLandingPage()">
          <v-list-item-content @click.stop="closeMenu('#news')">
            <v-list-item-title>
              {{ $t("menu.news") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content @click.stop="closeMenu('#contact')">
            <v-list-item-title>
              {{ $t("menu.contact") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isLandingPage()">
          <v-list-item-content @click.stop="closeMenu('#shop')">
            <v-list-item-title>
              {{ $t("menu.shop") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="language-tile">
          <v-list-item-content>
            <v-list-item-title>
              <v-select solo :items="langs" v-model="lang"/>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar flat v-if="isLandingPage() || isImpressum() || isPrivacy() || isImages()"
               :class="[{'scrolled' : navigation.scrolled}, {'whitened': !navigation.scrolled}]">
      <v-toolbar-title>
        <img @click="goToLanding()" alt="EBWM"
             src="../public/images/EBIKE_CUP_LOGO_SCHRIFT.svg">
      </v-toolbar-title>
      <v-spacer/>
      <v-toolbar-items v-if="$vuetify.breakpoint.mdAndDown">
        <v-btn icon class="menu-icon"
               @click.stop="navigation.drawer = !navigation.drawer" :ripple="false">
          <v-icon large>{{icons.menu}}</v-icon>
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-items v-else>
        <v-btn outlined v-if="!isLandingPage()"
               @click.prevent="goToLanding()">
          {{ $t("menu.home") }}
        </v-btn>
        <v-btn outlined v-if="isLandingPage()"
               @click.stop="closeMenu('#about')">
          {{ $t("menu.about") }}
        </v-btn>
        <v-btn outlined v-if="isLandingPage()"
               @click.stop="closeMenu('#events')">
          {{ $t("menu.events") }}
        </v-btn>
        <v-btn outlined v-if="isLandingPage()"
               @click.stop="closeMenu('#partner')">
          {{ $t("menu.partner") }}
        </v-btn>
        <v-btn outlined v-if="isLandingPage()"
               @click.stop="closeMenu('#news')">
          {{ $t("menu.news") }}
        </v-btn>
        <v-btn outlined v-if="isLandingPage()"
               @click.stop="closeMenu('#contact')">
          {{ $t("menu.contact") }}
        </v-btn>
        <v-btn outlined v-if="isLandingPage()"
               @click.stop="closeMenu('#shop')">
          {{ $t("menu.shop") }}
        </v-btn>
        <v-select solo :items="langs" v-model="lang"/>
      </v-toolbar-items>
    </v-toolbar>

    <router-view/>

    <div style="background-color: white;position: relative;">
      <Contact/>
      <Footer/>
    </div>

    <v-fab-transition>
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        fab
        dark
        fixed
        bottom
        right
        color="primary"
        @click="toTop">
        <v-icon>{{icons.arrowUp}}</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-app>
</template>

<script>
  /* eslint-disable no-console */
  import i18next from 'i18next';
  import { mdiMenu, mdiChevronUp, mdiClose } from '@mdi/js';

  const Contact = () => import(/* webpackChunkName: "Contact" */ './components/Contact');
  const Footer = () => import(/* webpackChunkName: "Footer" */ './components/Footer');

  export default {
    name: 'App',
    data() {
      return {
        icons: {
          menu: mdiMenu,
          arrowUp: mdiChevronUp,
          close: mdiClose,
        },
        fab: false,
        navigation: {
          scrolled: false,
          drawer: false,
        },
        langs: ['DE', 'EN'],
        lang: 'DE',
      };
    },
    components: {
      Contact, Footer,
    },
    watch: {
      lang(language) {
        this.$store.dispatch('setLanguage', language);
        this.$vuetify.lang.current = this.$store.getters.getLanguage.toLowerCase();
        i18next.changeLanguage(this.$store.getters.getLanguage);
      },
      $route(to, from) {
        if (to.name !== from.name) {
          this.closeMenu();
        }
      },
    },
    mounted() {
      window.addEventListener('scroll', () => {
        if (!this.isIE11()) {
          this.navigation.scrolled = window.scrollY > 50;
        } else {
          this.navigation.scrolled = window.pageYOffset > 50;
        }
      });
      this.$vuetify.lang.current = this.$store.getters.getLanguage.toLowerCase();
      i18next.changeLanguage(this.$store.getters.getLanguage);
      this.lang = this.$store.getters.getLanguage;
    },
    methods: {
      onScroll() {
        if (typeof window === 'undefined') return;
        const top = window.pageYOffset || document.documentElement.offsetTop || 0;
        this.fab = top > 50;
      },
      isLandingPage() {
        return this.$route.name === 'home';
      },
      isImpressum() {
        return this.$route.name === 'impressum';
      },
      isPrivacy() {
        return this.$route.name === 'privacy';
      },
      isImages() {
        return this.$route.name === 'images';
      },
      closeMenu(selector) {
        this.navigation.drawer = false;
        if (selector !== undefined && selector !== null) {
          this.globalEvents.$emit('goToElement', selector);
        }
      },
      toTop() {
        this.$vuetify.goTo(0);
      },
      goToLanding() {
        this.closeMenu();
        this.$router.push({ name: 'home' });
      },
      isIE11() {
        return window.navigator.userAgent.indexOf('Trident/7.0') > -1;
      },
      getLanguage() {
        return this.$store.getters.getLanguage;
      },
    }
  };
</script>

<style lang="scss">
  @import "assets/scss/variables";
  @import "assets/scss/layout";

  @font-face {
    font-family: 'Titillium Web';
    src: url('./assets/fonts/Titillium-Thin.woff') format('woff');
    font-weight: 200;
    font-style: normal;
  }
  @font-face {
    font-family: 'Titillium Web';
    src: url('./assets/fonts/Titillium-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: 'Titillium Web';
    src: url('./assets/fonts/Titillium-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'Titillium Web';
    src: url('./assets/fonts/Titillium-Semibold.woff') format('woff');
    font-weight: 600;
    font-style: normal;
  }
  @font-face {
    font-family: 'Titillium Web';
    src: url('./assets/fonts/Titillium-Bold.woff') format('woff');
    font-weight: 700;
    font-style: normal;
  }

  #app {
    font-family: $default-font;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: $primary-text;
    background: white;
    overflow: hidden;

    .v-list {
      .v-list-item {
        .v-list-item__content {
          text-align: left;
          color: $primary-text;
          font-family: $default-font;
        }
      }
    }

    .v-navigation-drawer {
      color: $primary-text;
      z-index: 1001;
      text-align: left;
      font-family: $default-font;

      .close-menu {
        svg {
          fill: $primary-text;
        }
      }

      .v-input {
        .v-input__control {
          .v-input__slot {
            padding: 0;
            box-shadow: none;
            min-height: 30px;
          }
          .v-text-field__details {
            display: none;
          }
        }
      }
    }

    .v-toolbar {
      background-color: transparent;
      box-shadow: unset;
      position: fixed;
      width: 100%;
      z-index: 100;

      /* IE11 */
      @media all and (-ms-high-contrast:none)
      {
        box-shadow: none;
      }

      .v-toolbar__content {
        .v-toolbar__title {
          img {
            width: auto;
            //height: 100px;
            //top: 25px;
            //left: 30px;
            height: 70px;
            top: 5px;
            left: 20px;
            position: absolute;
            cursor: pointer;
            -webkit-transition: width 0.2s ease, height 0.2s ease;
          }
        }
        .v-toolbar__items {
          .v-btn {
            border: none;
            text-transform: none;
            color: white;
            text-indent: 0;
            .v-btn__content {
              font-family: $default-font;
              font-weight: 600;
            }
          }
          .v-input {
            .v-input__control {
              height: 100%;
              .v-input__slot {
                max-width: 85px;
                background-color: transparent !important;
                box-shadow: unset !important;
                height: 100%;
                margin-bottom: 0;
                /* IE11 */
                @media all and (-ms-high-contrast:none)
                {
                  box-shadow: none !important;
                }
                .v-select__selections {
                  color: white;
                  font-weight: 500;
                  /* IE11 */
                  @media all and (-ms-high-contrast:none)
                  {
                    height: 31px;
                  }
                  input {
                    width: 5px;
                  }
                }
                .v-input__append-inner {
                  .v-input__icon {
                    svg {
                      color: white !important;
                    }
                  }
                }
              }
              .v-text-field__details {
                display: none;
              }
            }
          }
        }
      }

      .menu-icon {
        .v-icon {
          color: white;
        }
      }

      &.whitened {
        .v-toolbar__content {
          .v-toolbar__items {
            .v-btn {
              color: white;
            }
            .v-input {
              .v-input__control {
                .v-input__slot {
                  .v-select__selections {
                    color: white;
                    .v-select__selection--comma {
                      color: white;
                    }
                  }
                  .v-input__append-inner {
                    .v-input__icon {
                      svg {
                        color: white !important;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      &.scrolled {
        background-color: white;
        z-index: 100;
        box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2),
        0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12);
        .v-toolbar__content {
          img {
            height: 55px;
            top: 5px;
            left: 10px;
            -webkit-transition: width 0.2s ease, height 0.2s ease;
            @include MQ(XS) {
              top: 0;
            }
            @include MQ(S) {
              top: 0;
            }
          }
          .v-toolbar__items {
            .v-btn {
              color: $primary-text;
            }
            .v-input {
              .v-input__control {
                .v-input__slot {
                  .v-select__selections {
                    color: $primary-text;
                  }
                  .v-input__append-inner {
                    .v-input__icon {
                      svg {
                        color: $primary-text !important;
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .menu-icon {
          .v-icon {
            color: $primary-text;
          }
        }
      }
    }
  }
</style>
